export default __webpack_public_path__ + "static/media/resubmit-big.2f686b33.svg";